import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../_actions/matchesActions";
import * as profileActions from "../../_actions/profileActions";
import * as appActions from "../../_actions/appActions";
import InfiniteScroll from "react-infinite-scroller";
import UserWidgetContainer from "../Matches/UserWidgetContainer";
import Section from "../UI/Section";
import PageSubTitle from "../UI/PageSubTitle";
import getAcceptInvitations from "../../_selectors/matchesSelectors/getAcceptInvitations";
import getPeopleWhoLikedMe from "../../_selectors/matchesSelectors/getPeopleWhoLikedMe";
import getMatchesLastResult from "../../_selectors/matchesSelectors/getMatchesLastResult";
import { updateObject } from "../../_utils";
import matchesConstants from "../../_constants/matchesConstants";
import getMyLikesCount from "../../_selectors/userSelectors/getMyLikesCount";
import HoverWidget from "../UI/HoverWidget";
class LikedMe extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      getPeopleWhoLikedMe,
      likesCount,
      markAsRead
    } = this.props;
    updateHeader({
      title: "People Who Liked Me",
      description: "Members who liked you"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Liked Me", link: "/liked-me" }
    ]);
    getPeopleWhoLikedMe();
    if (likesCount > 0) {
      markAsRead();
    }
  }
  componentWillUnmount() {
    const { clearMembers, clearPeopleWhoLikedMe } = this.props;
    clearMembers();
    clearPeopleWhoLikedMe();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <div className="dev-table">
                <HoverWidget
                  title="No Members"
                  text="List of all the members who liked your profile"
                  link="/search"
                  linkText="Start Exploring Members"
                  success
                />
              </div>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.userId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getPeopleWhoLikedMe(state),
  lastResult: getMatchesLastResult(state),
  likesCount: getMyLikesCount(state)
});

const mapDispatchToProps = dispatch => ({
  getPeopleWhoLikedMe: () => dispatch(matchesActions.getPeopleWhoLikedMe()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearPeopleWhoLikedMe: () => dispatch(matchesActions.clearPeopleWhoLikedMe()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, {
          type: matchesConstants.GET_PEOPLE_WHO_LIKED_ME
        })
      )
    ),
  markAsRead: () => dispatch(matchesActions.markAllLikesAsRead())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LikedMe);



// WEBPACK FOOTER //
// ./src/_components/LikedMe/index.js